import { css } from '@emotion/react';

const customStyles = css`
table {
  class: center;
  margin-left:auto;
  margin-right:auto;
  border-spacing: 0;
  border-collapse: collapse;
  display: block;
  margin-top: 15px;
  margin-bottom: 10px;
  width: max-content;
  max-width: 100%;
  overflow: auto;
}
`;

export const styles = [customStyles];
